/* Rejuveen landing page — interactions */
(function () {
  'use strict';

  /* ---- smooth scroll for CTAs ---- */
  document.querySelectorAll('[data-scroll]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var t = document.querySelector(btn.getAttribute('data-scroll'));
      if (t) window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 12, behavior: 'smooth' });
    });
  });

  /* ---- FAQ accordion ---- */
  document.querySelectorAll('.faq-q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.closest('.faq-item');
      var ans = item.querySelector('.faq-a');
      var open = item.classList.toggle('open');
      ans.style.maxHeight = open ? ans.scrollHeight + 'px' : 0;
    });
  });

  /* ---- generic carousel ---- */
  function initCarousel(root) {
    if (!root) return;
    var track = root.querySelector('.car-track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.car-slide'));
    var dotsWrap = root.querySelector('.car-dots');
    var fade = root.classList.contains('expert');
    var i = 0;

    if (dotsWrap) {
      slides.forEach(function (_, idx) {
        var d = document.createElement('span');
        d.className = 'd' + (idx === 0 ? ' on' : '');
        d.addEventListener('click', function () { go(idx); });
        dotsWrap.appendChild(d);
      });
    }
    function render() {
      if (fade) {
        slides.forEach(function (s, idx) { s.classList.toggle('active', idx === i); });
      } else {
        track.style.transform = 'translateX(' + (-i * 100) + '%)';
        track.style.transition = 'transform .4s cubic-bezier(.4,0,.2,1)';
      }
      if (dotsWrap) dotsWrap.querySelectorAll('.d').forEach(function (d, idx) {
        d.classList.toggle('on', idx === i);
      });
    }
    function go(n) { i = (n + slides.length) % slides.length; render(); }
    var aPrev = root.querySelector('.car-arrow.prev');
    var aNext = root.querySelector('.car-arrow.next');
    aPrev.addEventListener('click', function () { go(i - 1); });
    aNext.addEventListener('click', function () { go(i + 1); });

    /* keep arrows centered on the PHOTO (not the quote text) for fade carousels */
    function placeArrows() {
      if (!fade) return;
      var ph = (slides[i] && slides[i].querySelector('.e-photo')) || root.querySelector('.e-photo');
      if (!ph) return;
      var top = ph.offsetTop + ph.offsetHeight / 2;
      aPrev.style.top = top + 'px'; aNext.style.top = top + 'px';
    }
    var _render = render;
    render = function () { _render(); placeArrows(); };
    window.addEventListener('resize', placeArrows);

    /* swipe */
    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
      x0 = null;
    });
    render();
  }
  initCarousel(document.getElementById('expertCar'));
  initCarousel(document.getElementById('sayingCar'));
  /* pricing is no longer a carousel — stacked on mobile, 3-up grid on desktop */

  /* ---- recent-purchase social-proof toast ---- */
  var toast = document.getElementById('toast');
  if (toast) {
    var names = ['Jessica M.', 'Linda K.', 'Sarah P.', 'Emily R.', 'Karen W.', 'Ashley D.',
      'Michelle T.', 'Amanda S.', 'Donna L.', 'Patricia H.', 'Barbara G.', 'Nancy F.',
      'Lisa B.', 'Sandra V.', 'Carol N.', 'Debra A.', 'Sharon E.', 'Cynthia R.'];
    var cities = ['NY', 'WY', 'WA', 'TX', 'CO', 'AZ', 'OR', 'FL', 'IL', 'MA', 'TN',
      'GA', 'CA', 'OH', 'NC', 'MI', 'VA', 'MN', 'MO', 'IN'];
    var dismissed = false;
    var msg = toast.querySelector('.toast-msg');
    var rand = function (a) { return a[Math.floor(Math.random() * a.length)]; };
    function fill() {
      var mins = 1 + Math.floor(Math.random() * 12);
      msg.innerHTML = '<b>' + rand(names) + '</b> from ' + rand(cities) +
        '<br>just bought <b>MYOTIDE</b> <span class="ago">· ' + mins + ' min ago</span>';
    }
    toast.querySelector('.x').addEventListener('click', function () {
      dismissed = true; toast.classList.remove('show');
    });
    function cycle() {
      if (dismissed) return;
      fill();
      toast.classList.add('show');
      setTimeout(function () { toast.classList.remove('show'); }, 5500);
    }
    setTimeout(cycle, 4000);      // first popup after 4s
    setInterval(cycle, 30000);    // then every 30s
  }

  /* ---- recompute open FAQ height on resize ---- */
  window.addEventListener('resize', function () {
    document.querySelectorAll('.faq-item.open .faq-a').forEach(function (a) {
      a.style.maxHeight = a.scrollHeight + 'px';
    });
  });

  /* ---- review pagination ---- */
  (function () {
    var pager = document.getElementById('reviewPager');
    var wrap = document.getElementById('reviewPages');
    if (!pager || !wrap) return;
    var pages = Array.prototype.slice.call(wrap.querySelectorAll('.review-page'));
    var total = pages.length;
    var cur = 1;
    function show(n) {
      cur = Math.min(Math.max(n, 1), total);
      pages.forEach(function (p) { p.hidden = (+p.getAttribute('data-page') !== cur); });
      pager.querySelectorAll('[data-page]').forEach(function (s) {
        s.classList.toggle('on', +s.getAttribute('data-page') === cur);
      });
      var head = document.querySelector('.sortbar');
      if (head) window.scrollTo({ top: head.getBoundingClientRect().top + window.pageYOffset - 16, behavior: 'smooth' });
    }
    pager.addEventListener('click', function (e) {
      var t = e.target.closest('[data-page],[data-nav]');
      if (!t) return;
      if (t.hasAttribute('data-page')) show(+t.getAttribute('data-page'));
      else if (t.getAttribute('data-nav') === 'next') show(cur + 1);
      else if (t.getAttribute('data-nav') === 'last') show(total);
    });
  })();
})();

/* ============================================================
   STAIRS VARIANT — Buy Box interactions
   ============================================================ */
(function () {
  /* ---- Tier select: radio + variant-id + dynamic total bar + Buy-Once link ---- */
  var plans = document.querySelectorAll('.bb-plan');
  var variantInput = document.getElementById('bb-variant-id');
  var ctaNow = document.querySelector('.bb-cta-now');
  var ctaWas = document.querySelector('.bb-cta-was');
  var onetimeLink = document.getElementById('bb-onetime-link');
  if (plans.length && variantInput) {
    plans.forEach(function (plan) {
      plan.addEventListener('click', function () {
        plans.forEach(function (p) { p.classList.remove('is-selected'); });
        plan.classList.add('is-selected');
        var radio = plan.querySelector('.bb-plan-input');
        if (radio) radio.checked = true;
        var variantId = plan.getAttribute('data-variant');
        if (variantId) variantInput.value = variantId;
        /* Update dynamic CTA price (data-total + data-was) */
        if (ctaNow) ctaNow.textContent = plan.getAttribute('data-total') || '';
        if (ctaWas) ctaWas.textContent = plan.getAttribute('data-was') || '';
        /* Update dynamic Buy-Once link (changes qty + label per tier) */
        if (onetimeLink) {
          var qty = plan.getAttribute('data-onetime-qty');
          var label = plan.getAttribute('data-onetime-label');
          if (qty) {
            onetimeLink.href = '/cart/add?id=55960842633556&quantity=' + qty + '&return_to=/checkout';
          }
          if (label) onetimeLink.textContent = label + ' →';
        }
      });
    });
  }

  /* ---- Thumb click: swap hero image ---- */
  var heroImg = document.getElementById('bb-hero-img');
  var thumbs = document.querySelectorAll('.bb-thumb');
  if (heroImg && thumbs.length) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var src = thumb.getAttribute('data-src');
        if (src) heroImg.src = src;
      });
    });
  }

  /* ---- Accordion toggle ---- */
  var accItems = document.querySelectorAll('.bb-acc-item');
  accItems.forEach(function (item) {
    var btn = item.querySelector('.bb-acc-q');
    if (!btn) return;
    btn.addEventListener('click', function () {
      item.classList.toggle('is-open');
    });
  });

  /* ---- Direct-checkout: subscription form (Get Your Gummies) ---- */
  var bbForm = document.getElementById('bb-form');
  if (bbForm) {
    bbForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var variantId = (document.getElementById('bb-variant-id') || {}).value;
      var sellingPlanRadio = bbForm.querySelector('input[name="selling_plan"]:checked');
      var sellingPlan = sellingPlanRadio ? sellingPlanRadio.value : null;
      if (!variantId) return;
      var fd = new FormData();
      fd.append('id', variantId);
      fd.append('quantity', '1');
      if (sellingPlan) fd.append('selling_plan', sellingPlan);
      fetch('/cart/clear.js', { method: 'POST' })
        .then(function () { return fetch('/cart/add.js', { method: 'POST', body: fd }); })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () { window.location.href = '/cart/' + variantId + ':1' + (sellingPlan ? '?selling_plan=' + sellingPlan : ''); });
    });
  }

  /* ---- Direct-checkout: Buy-Once link ---- */
  var bbOnetimeLink = document.getElementById('bb-onetime-link');
  if (bbOnetimeLink) {
    bbOnetimeLink.addEventListener('click', function (e) {
      e.preventDefault();
      var selectedPlan = document.querySelector('.bb-plan.is-selected');
      var qty = selectedPlan ? parseInt(selectedPlan.getAttribute('data-onetime-qty') || '3', 10) : 3;
      var oneTimeVariant = '55960842633556';
      var fd = new FormData();
      fd.append('id', oneTimeVariant);
      fd.append('quantity', String(qty));
      fetch('/cart/clear.js', { method: 'POST' })
        .then(function () { return fetch('/cart/add.js', { method: 'POST', body: fd }); })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () { window.location.href = '/cart/' + oneTimeVariant + ':' + qty; });
    });
  }
})();
